module.exports = __webpack_public_path__ + "img/zhaoshang_1v1@2x.85884781.png";